import { Preset, PresetsApiResponse } from '../api/PresetsMethodExecutor/PresetsMethodExecutor';

export function createPresetsList(response: PresetsApiResponse) {
    const apiItems = response.items;
    const isAdaptivePreset = (preset: Preset) => {
        if (preset.items && preset.items.length && preset.items[0].options) {
            return preset.items[0].options.isAdaptive;
        }

        return false;
    };

    apiItems.sort((preset1: Preset, preset2: Preset) => {
        if (isAdaptivePreset(preset1)) {
            return -1;
        }

        if (isAdaptivePreset(preset2)) {
            return 1;
        }

        return 0;
    });

    return apiItems.map(preset => {
        return {
            id: String(preset.id),
            thumbnail: preset.thumbnail,
            alt: preset.name,
            isAdaptive: isAdaptivePreset(preset)
        };
    });
}
